module.exports = __webpack_public_path__ + "img/home_chart_fr.e36bf3d.png";